export const RX_ARRAY_NOTATION = /\[(\d+)]/g;